import React from 'react';
import PropTypes from 'prop-types';
import {
	branch,
	compose,
	defaultProps,
	renderComponent,
	withHandlers,
	withProps,
	withState,
} from 'recompose';

import { Button } from 'components/core/Button';
import { PhoneNumber } from 'components/contact/PhoneNumber';

import './clickToShowCallButton.scss';

function ClickToShowCallButton() {
	return null;
}

ClickToShowCallButton.propTypes = {
	/** The phone number to display - e.g. (888) 777-6666 */
	phoneNumber: PropTypes.string.isRequired,
	unformattedPhoneNumber: PropTypes.string.isRequired,
	dark: PropTypes.bool,
	hideIcon: PropTypes.bool,
	asButton: PropTypes.bool,
	initialLabel: PropTypes.string,
};

function callNumber({ phoneNumber, hideIcon }) {
	return (
		<PhoneNumber
			phoneNumber={phoneNumber}
			hideIcon={hideIcon}
			size="standard"
		/>
	);
}

callNumber.propTypes = {
	phoneNumber: PropTypes.string,
	hideIcon: PropTypes.bool,
};

function callButton({
	isShowingNumber,
	label,
	link,
	tel,
	_handleClick,
	dark,
	outline,
}) {
	return (
		<div className="click-to-show-call-button">
			{!isShowingNumber && (
				<Button
					className="deferred-call-now"
					dark={dark}
					outline={outline}
					link={link}
					onClick={_handleClick}
				>
					{label}
				</Button>
			)}
			<Button
				className={!isShowingNumber ? 'instant-call-now' : 'call-now'}
				dark={dark}
				outline={outline}
				link={link}
				href={tel}
				onClick={_handleClick}
				id="call-now-button"
			>
				{label}
			</Button>
		</div>
	);
}

callButton.propTypes = {
	isShowingNumber: PropTypes.bool,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	tel: PropTypes.string,
	link: PropTypes.bool,
	_handleClick: PropTypes.func,
	dark: PropTypes.bool,
	outline: PropTypes.bool,
};

const enhance = compose(
	defaultProps({
		initialLabel: 'Call facility',
	}),
	withState('isShowingNumber', 'setShowingNumber', false),
	withProps((props) => ({
		tel: `tel:${props.unformattedPhoneNumber}`,
		label: props.isShowingNumber ? callNumber(props) : props.initialLabel,
	})),
	withHandlers({
		_handleClick:
			({ isShowingNumber, setShowingNumber }) =>
			() => {
				if (!isShowingNumber) {
					setShowingNumber(true);
				}
			},
	}),
	branch(
		({ isShowingNumber, asButton }) => isShowingNumber && !asButton,
		renderComponent(callNumber),
		renderComponent(callButton)
	)
);

export default enhance(ClickToShowCallButton);
